module.exports = __webpack_public_path__ + "static/img/040_3.7b506ac.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/img/040_3.jpg
// module id = hevC
// module chunks = 1